var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import styled from 'styled-components';
import { GRID_UNIT } from '../../utilities/grid';
export var FieldHeader = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  min-height: 24px;\n  display: flex;\n  margin-bottom: ", "px;\n  & > *:first-child {\n    flex-grow: 1;\n  }\n"], ["\n  width: 100%;\n  min-height: 24px;\n  display: flex;\n  margin-bottom: ", "px;\n  & > *:first-child {\n    flex-grow: 1;\n  }\n"])), GRID_UNIT / 2);
var templateObject_1;